import React, { useRef, useEffect, useCallback, useState} from 'react';
import {useKeys} from './useKeys.js';
import SavePad from './SavePad.js';
import {setPadsExpand} from 'actions/index.js';
import ContextMenu from "components/dropdowns/ContextMenu.js";
import MenuItem from "components/dropdowns/MenuItem.js";
import {useContextMenu} from "components/dropdowns/useContextMenu.js";
import Documented from "components/help/Documented.js";
import {
    PADS_EXPAND_BUTTON
} from "constants/contextual-help.js";
import PadWaveform from './PadWaveform.js';
import TrackComponent from "components/v2/TrackComponent.js";
import PadToolbar from './PadToolbar.js';
import PadSlot from './PadSlot.js';
import PadVisualizer from './PadVisualizer.js';
import {WAVEFORM, DELETE, MUTES} from './modes.js';
import {connect} from 'react-redux';

const PadComponent = ({
    pad,
    scrollContainer,
    selectedTrack,
    tracks,
    setPadExpand,
    trackToShow,
    setTrackToShow,
    isPulled
}) => { 
    let ref = useRef(undefined);
    let padRef = useRef(undefined);

    const {onContextMenu, setDropdownPos, dropdownPos} = useContextMenu(
        {ref: padRef});

    let [saving, setSaving] = useState(false);
    let [mode, setMode] = useState(undefined);

    useKeys({pad, setTrackToShow, trackToShow, selectedTrack});

    useEffect(() => {
        let track = pad.tracks.find((x,i) => x && x.trackNumber === selectedTrack);
        if (track && trackToShow !== undefined) {
            setTrackToShow(track);
        }
    }, [trackToShow, selectedTrack, setTrackToShow, pad, tracks]);

    const toggleCollapse = useCallback(() => {
        if (trackToShow) {
            return setTrackToShow(undefined);
        }
        if (selectedTrack !== undefined) {
            let track = pad.sequencerEngine.tracks[selectedTrack];
            if (pad.tracks.some(x => x === track)) {
                setTrackToShow(track);
                return;
            }
        }
        let tracks = pad.tracks.filter(x => x);
        if (tracks.length === 0) {
            return;
        }
        setTrackToShow(tracks[0]);
    }, [selectedTrack, trackToShow, pad, setTrackToShow]);

    const clearPattern = useCallback(() => {
        pad.slotTracks.forEach(({pattern}) => pattern.clear());
        pad.sequencerEngine.updateTracks();
    }, [pad]);


    let className = "pads";
    if (mode===DELETE) {
        className += " delete-mode";
    } else if (mode === MUTES) {
        className += " mute-mode";
    }

    if (saving) {
        return (
            <SavePad hide={() => setSaving(false)} pad={pad}/>
        );
    }

    return (
        <div
          ref={padRef}
          onContextMenu={onContextMenu}
          onDrop={(e) => e.stopPropagation()}
          className={className}>
          <div className="pad-inner">
            <ContextMenu dropdownPos={dropdownPos}>
              <MenuItem onMouseDown={clearPattern}>
                Clear Pattern
              </MenuItem>
              <MenuItem onMouseDown={() => setSaving(true)}>
                Save as Pack
              </MenuItem>
              <MenuItem onMouseDown={() => pad.deletePad()}>
                Delete Pad
              </MenuItem>
            </ContextMenu>
            <Documented
              element={PADS_EXPAND_BUTTON}
              onClick={toggleCollapse}
              className="collapse-container">
              <div
                className={trackToShow ? "arrow-right" : "arrow-down"}/>
            </Documented>
            <div className="slots-and-track">

              <div>
            <PadToolbar
              mode={mode} setMode={setMode} pad={pad}/>
            <div className="pad-slots">
              {pad.tracks.map(
                  (slot, slotNumber) =>
                      <PadSlot
                        setTrackToShow={setTrackToShow}
                        trackToShow={trackToShow}
                        key={slotNumber}
                        slotNumber={slotNumber}
                        pad={pad}
                        slot={slot}
                        mode={mode}
                      />)}
            </div></div>
          {trackToShow ?
           <TrackComponent
             isDraggable={false}
             onHide={() => setTrackToShow(undefined)}
             forceShow={true}
             track={trackToShow}
             scrollContainer={scrollContainer}/> : ''}
            </div>
            <div className="pad-bottom" ref={ref}>
              {mode === WAVEFORM ? <PadWaveform div={ref} pad={pad}/> :
               !isPulled && <PadVisualizer trackToShow={trackToShow} container={padRef} pad={pad}/>}
            </div>
          </div>
       </div>);
}

const mapStateToProps = (state, props) => {
  return {
      tracks: props.pad.tracks,
      selectedTrack: state.mix.selectedTrack,
      trackToShow: state.pads.padsExpand && state.pads.padsExpand.pad === props.pad ?
          state.pads.padsExpand : undefined
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setTrackToShow: x => dispatch(setPadsExpand(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PadComponent);
